module.exports = __webpack_public_path__ + "img/3.753a265c.png";